import React, { useState, useEffect } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { authApi, teamApi } from '../api';
import { getUrlParams, formatMd5Name } from '../utils';
import { useAuth } from '../components/context';

import Loader from '../components/common/Loader';
import RedirectRoute from '../components/routes/RedirectRoute';

function ConfirmTeam({ user, t, app, updateApp, setAlert }) {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { token } = useParams();
  const { env } = useAuth();
  const params = getUrlParams();
  const inviteEnv = params.env || env;

  const getInvitation = async (email) => {
    try {
      const response = await teamApi.getInvitation(token, email, inviteEnv);
      updateApp({
        invitation: {
          token: token,
          team_name: user
            ? formatMd5Name(response.team_name, user.company.name)
            : response.team_name,
          role_name: response.role_name,
          email: email,
          env: inviteEnv,
        },
      });
    } catch (error) {
      setAlert({
        message: t('invite.messages.invalid', {
          env: t(`env.${inviteEnv}.label`),
        }),
        variant: 'danger',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmAccountExists = async (email) => {
    try {
      const exists = await authApi.confirmAccountExists(email, inviteEnv);
      if (exists) {
        setAlert({ message: t('invite.messages.auth'), variant: 'warning' });
        navigate('/login', {
          state: {
            from: location.pathname,
            search: location.search,
            invitationEnv: inviteEnv,
            handle: params.email,
          },
        });
      } else {
        getInvitation(email);
        navigate({ pathname: '/register', state: { from: location.pathname } });
      }
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading && !user && params.email) {
      confirmAccountExists(params.email);
    } else if (user && !app.invitation) {
      getInvitation(user.entity.emails[0].email);
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) return <Loader />;

  return <RedirectRoute />;
}

export default ConfirmTeam;
